/**
 * VÉRAULT — dynamic event state for Essentials (Up Next / Today / Upcoming /
 * Completed). Uses the real current time. A group's earliest non-completed item
 * is flagged "Up Next".
 */
export const STATE_META = {
  up_next: { label: "Up Next", cls: "bg-[hsl(var(--accent-gold))] text-white" },
  today: { label: "Today", cls: "bg-[hsl(var(--accent-gold))]/15 text-[hsl(var(--accent-gold))]" },
  upcoming: { label: "Upcoming", cls: "bg-[rgba(0,0,0,0.05)] text-[hsl(var(--foreground-secondary))]" },
  completed: { label: "Completed", cls: "bg-[rgba(0,0,0,0.04)] text-[hsl(var(--foreground-muted))]" },
};

export function classifyEvent(startISO, endISO, now = new Date()) {
  const start = startISO ? new Date(startISO) : null;
  const end = endISO ? new Date(endISO) : start;
  if (!start || isNaN(start.getTime())) return { key: "upcoming", ts: Infinity, startMs: Infinity };
  const ts = start.getTime();
  const nowMs = now.getTime();
  if (end && !isNaN(end.getTime()) && end.getTime() < nowMs) return { key: "completed", ts, startMs: ts };
  if (ts <= nowMs) return { key: "today", ts, startMs: ts }; // in progress / started
  if (start.toDateString() === now.toDateString()) return { key: "today", ts, startMs: ts }; // starts later today
  return { key: "upcoming", ts, startMs: ts };
}

/**
 * Annotate a list with {_state, _ts, _next}, sort chronologically (completed
 * sink to the bottom), and flag the earliest NOT-YET-STARTED item as Up Next.
 */
export function withEventStates(items, getStart, getEnd) {
  const now = new Date();
  const nowMs = now.getTime();
  const annotated = items.map((it) => {
    const c = classifyEvent(getStart(it), getEnd ? getEnd(it) : null, now);
    return { ...it, _state: c.key, _ts: c.ts, _startMs: c.startMs };
  });
  annotated.sort((a, b) => {
    const ac = a._state === "completed", bc = b._state === "completed";
    if (ac !== bc) return ac ? 1 : -1; // completed last
    return a._ts - b._ts;
  });
  const firstNext = annotated.find((x) => x._state !== "completed" && x._startMs > nowMs);
  return annotated.map((x) => ({ ...x, _next: firstNext && x.id === firstNext.id }));
}

export function stateLabel(item) {
  return item._next ? STATE_META.up_next : STATE_META[item._state] || STATE_META.upcoming;
}
